export const ROLES = {
    PORTFOLIO_ADMIN: 922,
    SUPER_ADMIN: 920,
    ADMIN: 917,
    PROJECT_MANAGER: 918,
    RL_ADMN: 1,
    RL_AGND: 6,
    RL_AGND_ADM: 8,
    RL_APPS_INTERNES: 900,
    RL_AS_ADMIN: 910,
    RL_AS_READER: 912,
    RL_AS_STRATEGIST: 911,
    RL_DBA: 99,
    RL_GUEST: 914,
    RL_GUEST_2: 921,
    RL_NEWS: 9,
    RL_QS_ACTEUR: 906,
    RL_QS_ADMIN: 905,
    RL_QS_MOA_MULTI: 903,
    RL_QS_MOA_SOLO: 904,
    RL_RESELLER: 901,
    USER: 919,
} as const;

export const ROLES_TRANSLATIONS = {
    [ROLES.ADMIN]: 'roles.admin',
    [ROLES.PROJECT_MANAGER]: 'roles.project_manager',
    [ROLES.USER]: 'roles.user',
    [ROLES.SUPER_ADMIN]: 'roles.super_admin',
    [ROLES.PORTFOLIO_ADMIN]: 'roles.portfolio_admin',
    [ROLES.RL_ADMN]: 'roles.unknown',
    [ROLES.RL_AGND]: 'roles.unknown',
    [ROLES.RL_AGND_ADM]: 'roles.unknown',
    [ROLES.RL_APPS_INTERNES]: 'roles.unknown',
    [ROLES.RL_AS_ADMIN]: 'roles.unknown',
    [ROLES.RL_AS_READER]: 'roles.unknown',
    [ROLES.RL_AS_STRATEGIST]: 'roles.unknown',
    [ROLES.RL_DBA]: 'roles.unknown',
    [ROLES.RL_GUEST]: 'roles.unknown',
    [ROLES.RL_GUEST_2]: 'roles.unknown',
    [ROLES.RL_NEWS]: 'roles.unknown',
    [ROLES.RL_QS_ACTEUR]: 'roles.unknown',
    [ROLES.RL_QS_ADMIN]: 'roles.unknown',
    [ROLES.RL_QS_MOA_MULTI]: 'roles.unknown',
    [ROLES.RL_QS_MOA_SOLO]: 'roles.unknown',
    [ROLES.RL_RESELLER]: 'roles.unknown',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];
